export default "__VITE_ASSET__FwGrX8r$__"